import { Component, OnInit, PLATFORM_ID, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, API } from '../../../../core/constants'
import { API as AWS_API } from 'aws-amplify';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ConfirmationDialogComponent } from 'src/app/pages/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { ConsumerSignInComponent } from '../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { IOSModalDialog } from '../../indigenous-cloud/album-list/album-list.component';
import { AppService } from 'src/app/core/services/app.service';
import { Title } from '@angular/platform-browser';
import * as moment from 'moment';

@Component({
  selector: 'app-subscription-list',
  templateUrl: './subscription-list.component.html',
  styleUrls: ['./subscription-list.component.scss']
})
export class SubscriptionListComponent implements OnInit {

  userInfo: any = {};
  userInfoSubscription: Subscription;
  subscriptionList: any = [];
  isShownSideBar = false;
  selectedPlan: any = {};
  performer_details: any = {};
  subscription_details: any = [];
  currentLocation: any;
  currencyInfoSubscription: Subscription;
  getCurrency: any;
  settingsData: any = {};
  @Input('planIds') planIds: any = [];
  @Input('creatorCurrency') creatorCurrency: any = '';
  perfomerInfoData: any;
  organizationId: any;
  getCurrencytype: any;
  settingsDataSubscription: Subscription;
  performerInfoSubscr: Subscription;
  performerData: any;
  deviceType: string;
  deviceData: Subscription;
  routerevents: any;
  planName: any;
  showMsg: boolean = false;
  checkSubStatus: any = [];
  failedSubList: any = [];
  trackEvents = false;
  deviceInfo: string = 'web';
  showReferralCodeInvalidMessage:boolean = false;

  constructor(private commonSubscribeService: CommanSubscribeService,
    private route: ActivatedRoute, private dialog: MatDialog, public router: Router,
    private appPaymentService: AppPaymentTVService,
    private toastr: ToastrService,
    private ngxLoader: NgxUiLoaderService, private appService: AppService,
    private storageService: StorageService,
    private titleService: Title) { }


  ngOnInit() {
    // ngOnInit is re-run after sign-in and after a free-plan subscription; drop the previous run's
    // subscriptions so each update calls getSubscriptionList() once, not once per run.
    [this.deviceData, this.userInfoSubscription, this.settingsDataSubscription,
      this.currencyInfoSubscription, this.performerInfoSubscr].forEach(sub => sub?.unsubscribe());
    this.deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.deviceType = this.commonSubscribeService.deviceType;
    this.deviceData = this.commonSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    })

    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      if (response && response.id) {
        this.getSubscriptionList();
      }
    });

    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      this.getSubscriptionList();
    });
    this.perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    this.organizationId = this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
    //console.log(this.perfomerInfoData)
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getSubscriptionList();
      }
    });

    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
      if (response.data.Subscription_details)
        this.getSubscriptionList();
    })

    this.getCurrency = this.storageService.getItem('currency');
    this.getSubscriptionList();
    if (this.router.url.includes('/c') && this.router.url.includes('/preview')) {
      this.isShownSideBar = true;
    }
    
    if (this.deviceInfo != "web" && this.route.snapshot.queryParams.user_id) {
      this.getUserInfo(() => {
        this.getSubscriptionList();
      })
    }

  }

  getUserInfo(callback) {
    let id = this.commonSubscribeService.getParam("user_id");
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        // "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "user_id": id,
        "organization_id": this.organizationId
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
      // this.loader.stop();
      if (response.data.user) {
        let token = this.commonSubscribeService.getParam("token");
        if (token) {
          response.data.user.access_token = token
        } else {
          response.data.user.access_token = response.data.user.session_token;
        }
        this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
        this.commonSubscribeService.sendUserInfo(this.userInfo);
      }
      callback();
    }).catch(error => {
      // this.loader.stop();
    });
  }

  goback(from?) {
    const pName = this.route.snapshot.params.pName;
    const urlSegments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
    const segment2 = urlSegments[1];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list', 'preview'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${pName}/${groupSlug}` : `/${pName}`;
    if (!this.settingsData.is_preview) {
      if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id && this.settingsData.channelInfo.channel_id != 0)
        this.router.navigate([`${base}/channel/` + this.settingsData.channelInfo.channel_name])
      else
        this.router.navigate([base]);
    } else {
      this.router.navigate([`/${pName}/preview`], { queryParams: { token: this.route.snapshot.queryParams.token } });
    }
    // this.router.navigate([this.route.snapshot.params.pName])
  }
  subscription_detail_data: boolean = true;
  subscribedChannels: any = [];
  getSubscriptionList() {
    this.subscriptionList = [];
    this.getCurrency = this.storageService.getItem('currency');
    this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let currentCode = code.includes('\"') ? JSON.parse(code) : code;
    let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
    let channel_name = this.router.url.split("/")[1];
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        "channel_name": channel_name,
        "currency": localCurrency ? localCurrency : currentCode,
        "user_id": this.userInfo.id
      }
    }
    this.ngxLoader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data).then(response => {
      this.titleService.setTitle(response.data.Data[0].channel_display_name);
      console.log("pagetitle",response,response.data.Data[0].channel_display_name);
      this.ngxLoader.stop();
      if (response.data.statusCode === '200') {
        if (!this.trackEvents) {
          this.trackEvents = true;
          //console.log('add_to_cart');
          this.commonSubscribeService.trackGoogleAnalytics('add_to_cart');
          this.commonSubscribeService.trackFBEvents('AddToCart');
        }
        let list;
        this.performerData = response;
        let cId;
        if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.channel_id) {
          cId = this.settingsData.channelInfo.channel_id;
        }
        if (this.router.url.includes('/channel/')) {
          if (this.settingsData && this.settingsData.channelInfo && this.settingsData.channelInfo.subscription == 0) {
            cId = 0;
          }
        }

        let tempSubscribedPlansList = response.data.Subscription_details || [];
        let freePlansInSubDetails = [];
        let unExpiredPlans = [];
        let currentDate:any;
        let freePlanIndex = null;
        currentDate = new Date();
        currentDate = moment(currentDate).format('YYYY/DD/MM HH:mm:ss')
        if(tempSubscribedPlansList.length>1){
          freePlansInSubDetails = tempSubscribedPlansList.filter( a => a.tier_amount_mode && a.tier_amount_mode == 'noExpiry');
          freePlanIndex = freePlansInSubDetails.length >0 ? tempSubscribedPlansList.findIndex(a => a.plan_id == freePlansInSubDetails[0]['plan_id']):null;
          unExpiredPlans = tempSubscribedPlansList.filter( a => a.subscription_end_date && a.subscription_end_date > currentDate && a.tier_amount_mode != 'noExpiry');
          if(unExpiredPlans.length>0){
            tempSubscribedPlansList.splice(freePlanIndex,1)
          }
        }
        this.subscribedChannels = tempSubscribedPlansList; // response.data.Subscription_details || [];
        if (this.subscribedChannels && this.subscribedChannels.length > 0) {
          this.subscription_details = [];
          this.subscribedChannels.forEach(el => {
            if (el.channel_id == cId || (!el.channel_id && !this.router.url.includes('/channel'))) {
              this.subscription_details.push(el);
            }
            // this.subscription_details = this.subscribedChannels.filter(el => el.channel_id == cId || !el.channel_id)
          });
        }
        if (this.subscription_details) {
          this.commonSubscribeService.sendSubscriberPayedInfo(response.data.Subscription_details)
        }
        // Resolve active group from URL slug (works on refresh too)
        const urlSegments = this.router.url.split('?')[0].split('/').filter(s => s !== '');
        const urlGroupSlug = urlSegments.length >= 2 && !['channel', 'subscription-list', 'album', 'event'].includes(urlSegments[1]) ? urlSegments[1] : '';
        const groups = response.data.Data[0].groups || [];
        const activeGroupFromUrl = urlGroupSlug ? groups.find(g => g.group_slug === urlGroupSlug) : null;
        const activeGroupId = activeGroupFromUrl
          ? activeGroupFromUrl.id
          : (urlGroupSlug ? this.commonSubscribeService.activeGroupId : 0);
        const activeGroup = activeGroupId > 0 ? (activeGroupFromUrl || groups.find(g => g.id === activeGroupId)) : null;
        const channelInfo = this.settingsData && this.settingsData.channelInfo;
        const useGroupPlans = this.shouldUseGroupPlans(activeGroup, channelInfo);

        if (useGroupPlans) {
          // Group context: always reset first, then use plans from the active group
          this.subscriptionList = [];
          if (activeGroup && activeGroup.plans) {
            list = activeGroup.plans.filter(p => p !== null && p !== undefined);
            if (this.planIds.length == 0) {
              this.subscriptionList = list;
            } else {
              list.forEach(element => {
                if (this.planIds.includes(element.id)) {
                  this.subscriptionList.push(element);
                }
              });
            }
          }
        } else if (response && response.data && response.data.Data[0] && response.data.Data[0].plans) {
          list = response.data.Data[0].plans.filter(p => p !== null && p !== undefined);
          if (this.planIds.length == 0) {
            this.subscriptionList = list;
          } else {
            list.forEach(element => {
              if (this.planIds.includes(element.id)) {
                this.subscriptionList.push(element);
              }
            });
          }
        }

        if(useGroupPlans){
            this.subscriptionList = this.subscriptionList.filter(element => element && element.network_group_id == activeGroupId);
        } else {
          this.subscriptionList = this.subscriptionList.filter(element => element && (element.network_group_id == 0 || element.network_group_id == null || element.network_group_id == undefined));
        }

        let filterSubscriptions = [];
        if (this.subscriptionList && this.subscriptionList.length > 0) {
          filterSubscriptions = this.resolveChannelPlans(this.subscriptionList, useGroupPlans, this.settingsData && this.settingsData.channelInfo);

           // Send free plan to beginning in list starts here
          let freePlan = filterSubscriptions.filter( a => a.plan_type && a.plan_type == 'free');
          let rearrangedPlans = [];
          if(freePlan.length == 1){
            rearrangedPlans.push(freePlan[0]);
            filterSubscriptions.forEach(filterSubElement => {
              if(freePlan[0]['id'] != filterSubElement.id){
                rearrangedPlans.push(filterSubElement)
              }
            });
            filterSubscriptions = rearrangedPlans;
          }
          // Send free plan to beginning in list ends here


          // Check if there is referral code in URL, starts here
          if (this.router.url.includes('?ref=') && filterSubscriptions && filterSubscriptions.length > 0) {
            let tempFilterSubscriptions = filterSubscriptions;
            let subscription_referral_code = this.router.url.split('?ref=')[1];
            let organizationAffiliates = [];
            // Get affiliate plans to check if it is active or not
            let url = API.GET_AFFILIATES;
            let PAYLOAD = { organization_id: response.data.Data[0].organization_id };
            this.appService.postRequest(url, PAYLOAD).subscribe(orgAffiliatesResult => {
              if (orgAffiliatesResult.status == 0) {
                if (orgAffiliatesResult.result && orgAffiliatesResult.result.length > 0) {
                  orgAffiliatesResult.result.forEach(orgResElement => {
                    if (orgResElement.active_status == 1) {
                      organizationAffiliates.push(orgResElement.referral_code)
                    }
                  });
                }
                tempFilterSubscriptions.forEach((plansElement, index1) => {
                  let planCodesList = [];
                  plansElement.referral_codes.forEach(refCode => {
                    if (organizationAffiliates.includes(refCode)) {
                      planCodesList.push(refCode)
                    }
                  });
                  tempFilterSubscriptions[index1]['referral_codes'] = planCodesList;
                });
                // Check if the url referral code in url includes in the referral_codes list of a plan
                tempFilterSubscriptions = tempFilterSubscriptions.filter(
                  a => a['referral_codes'].includes(subscription_referral_code)
                )
                this.showReferralCodeInvalidMessage = false;
                if(tempFilterSubscriptions.length>0){                // If referral code is present and valid
                  this.subscriptionList = tempFilterSubscriptions;
                }else{
                  this.subscriptionList = filterSubscriptions;      // If referral code is present and invalid (random), then show all plans
                  this.showReferralCodeInvalidMessage = true;
                }
              }
            }, error => {
              console.log(error);
            })
          } else {
            this.subscriptionList = filterSubscriptions;
          }
          // Check if there is referral code in URL, ends here
        }

        this.subscriptionList.forEach(e => {
          if (this.subscription_details) {
            this.subscription_details.forEach(el => {
              if (el.plan_id == e.id) {
                el.plan_name = e.plan_name;
                this.planName = e.plan_name;
                if(e.amounts && e.amounts.length>0){
                  e.tier_amounts.forEach(element => {
                    if (element.frequency == el.tier_amount_mode) {
                      e.subscription_amount = el.subscription_amount;
                      e.current_currency = el.currency;
                      e.discount_percentage = el.discount_percentage;
                      e.isPayment = el.payment;
                    }
                  });
                }
              }
            });
          }
          if (response.data.Data[0].performer_details) {
            this.performer_details = response.data.Data[0].performer_details;
          }
          e.new_benefits = typeof e.benefits === 'string' ? JSON.parse(e.benefits) : e.benefits;;
          e.plan_description = e.plan_description ? JSON.parse(e.plan_description) : [];
          e.subType = e.tier_amount_mode;
          if(e.tier_amounts && e.tier_amounts.length>0){
            e.tier_amounts.forEach(element => {
              if (e.subType == element.frequency) {
                e.discount_val = element.discount;
                e.org_amount = Number(element.amount).toFixed(2);
                e.current_currency = element.currency;
                e.amount_after_dis_no_bf = (e.org_amount - (e.org_amount * e.discount_val / 100));
                e.amount_after_dis_no_bf = Number(e.amount_after_dis_no_bf).toFixed(2);
                if (this.performer_details.booking_fee && this.performer_details.booking_fee != 0) {
                  e.booking_fee = (this.performer_details.booking_fee / 100) * e.amount_after_dis_no_bf;
                  e.booking_fee = Number(e.booking_fee).toFixed(2);
                  e.amount_after_dis = (Number(e.booking_fee) + Number(e.amount_after_dis_no_bf));
                  e.amount_after_dis = Number(e.amount_after_dis).toFixed(2);
                } 
                //else {
                if ((e.processing_fee && e.processing_fee == 1) || e.processing_fee == undefined) {
                  e.processingFee = (e.amount_after_dis_no_bf * (environment.processing_fee / 100)) + environment.fee_percentage;
                  e.processingFee = Number(e.processingFee.toFixed(2));
                  e.amount_after_dis = (Number(e.processingFee) + Number(e.amount_after_dis_no_bf));
                } else if(e.processing_fee == 0){
                  e.amount_after_dis = Number(e.amount_after_dis_no_bf).toFixed(2);
                }
                // }
              }
            });
          }
          e.selectedPlan = this.commonSubscribeService.checkIsSubscribePlan(this.subscription_details, e.id);
          e.reActivePlan = this.commonSubscribeService.checkIsSubscribePlanReActive(this.subscription_details, e.id);
          e.isSubFailed = this.commonSubscribeService.checkIsSubscribeFailed(this.subscription_details, e.id);
          // e.selectedPlanValue = this.commonSubscribeService.getSelectedPlanValue(this.subscription_details, e.id);
          if (e.selectedPlan || e.reActivePlan) {
            this.commonSubscribeService.getSubscribedAmount(this.subscription_details, e);
            if (this.route.snapshot.queryParams.returnUrl) {
              this.router.navigate([decodeURIComponent(this.route.snapshot.queryParams.returnUrl)]);
            }
          }
          if (this.subscription_details) {
            this.subscription_details.forEach(el => {
              if (el.plan_id == e.id) {
                e.new_tire_amount_mode = el.tier_amount_mode;
                e.end_date = el.tier_amount_mode != "noExpiry" ? el.subscription_end_date: '';
              }
            });
          }
        });
        if (this.subscription_details.length > 0) {
          const contextPlanIds = new Set((this.subscriptionList || []).map(p => p.id));
          this.checkSubStatus = this.subscription_details.filter(el => el.payment == 'success' && contextPlanIds.has(el.plan_id));
          this.failedSubList = this.subscription_details.filter(el => el.payment == 'failed');
        }
        let tierAmountMode;
        if (this.subscriptionList && this.subscriptionList[0]) {
          tierAmountMode = this.subscriptionList[0].tier_amount_mode;
        }

        //remains currency for subscription amount when changing diff currencies
        this.subscriptionList.forEach(e => {
          if (e.currency && e.currency !== e.current_currency) {
            e.current_currency=e.currency
          }
        });

        let mode = this.subscription_details && this.subscription_details[0] ? this.subscription_details[0].tier_amount_mode : tierAmountMode;
        this.changeSub(mode, '');

      }

    });


    //console.log(this.subscriptionList, this.subscriptionList[0], 'list');
  }

  // A group only gets its own plan list when it has its own separate subscription plan
  // (separate_subscription_plan == 1); otherwise it inherits the network-level plans,
  // same as if no group were selected at all. EXCEPT: if the channel itself has its own
  // dedicated plan (channelInfo.subscription == 1), that plan lives inside the group's
  // plan set (network_group_id == activeGroup.id) regardless of the group's own flag —
  // so it must still be sourced from activeGroup.plans.
  private shouldUseGroupPlans(activeGroup: any, channelInfo: any): boolean {
    const channelHasOwnPlan = !!(channelInfo && channelInfo.subscription == 1 && channelInfo.channel_id);
    return !!(activeGroup && (activeGroup.separate_subscription_plan == 1 || channelHasOwnPlan));
  }

  // Decides which plans to show for the current channel/group context.
  // Table (see design.md — channel-subscription-plan-resolution spec):
  //   useGroupPlans && channel has its own plan (channelInfo.subscription==1)
  //     -> that channel's own plan, scoped inside the group's plan set
  //   useGroupPlans (channel has no own plan)
  //     -> the group's shared plan (channel_id == 0)
  //   !useGroupPlans && channel has its own plan
  //     -> that channel's own plan, network-level
  //   !useGroupPlans (channel has no own plan, or no channel in context)
  //     -> the network's shared plan (channel_id == 0)
  private resolveChannelPlans(subscriptionList: any[], useGroupPlans: boolean, channelInfo: any): any[] {
    const channelHasOwnPlan = !!(channelInfo && channelInfo.subscription == 1 && channelInfo.channel_id);
    const filterSubscriptions = [];
    if (useGroupPlans && channelHasOwnPlan) {
      return subscriptionList.filter(element => element && element.delete_status == 0 && element.channel_id == channelInfo.channel_id);
    }
    if (useGroupPlans) {
      // Group-wide plan: exclude channel-specific plans (only channel_id == 0 / unset
      // belongs at the group level), filter out deleted
      return subscriptionList.filter(element => element && element.delete_status == 0 && (element.channel_id == 0 || !element.channel_id));
    }
    if (channelHasOwnPlan) {
      subscriptionList.forEach(element => {
        if (element.channel_id == channelInfo.channel_id) {
          filterSubscriptions.push(element);
        }
      });
      return filterSubscriptions;
    }
    subscriptionList.forEach(element => {
      if (element.channel_id == 0 || !element.channel_id) {
        filterSubscriptions.push(element);
      }
    });
    return filterSubscriptions;
  }

  redirectTo() {
    this.isShownSideBar = !this.isShownSideBar;
  }

  toggleSubscribeSideMenu(event?) {
    if (event != "success") {
      this.isShownSideBar = !this.isShownSideBar;
      if (event == "close") {
        this.isShownSideBar = false;
      }
    } else {
      this.getSubscriptionList();
    }
    if (this.router.url.includes('/album/')) {
      // setTimeout(() => {
      this.commonSubscribeService.sendSubscribePayInfo(true);
      // }, 100);
    }
  }

  doSubscribePayment(plan) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} subscription clicked - ${userId}`)
    const data = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} subscription clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: plan?.organization_id || null,
      networkGroupId: plan?.network_group_id || null,
      clickAction:'subscribe'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);

    if (this.deviceType != 'ios') {
      if (this.userInfo.id) {
        plan.tier_amount_mode = plan.subType;
        this.isShownSideBar = false;
        this.selectedPlan = plan;
        if(!plan.plan_type || plan.plan_type == 'paid'){
          setTimeout(() => {
            this.isShownSideBar = true;
          }, 20);
        }else{
          const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '370px',
            panelClass: 'app-confirmation-dialog',
            data: {
              title: "Are you sure you want to subscribe to this plan?"
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result == 'yes'){
              this.subscribeToFreePlan(plan);
            }
          });
        }
      }
      else {
        this.storageService.setItem('skipIcRedirection', this.router.url);
        const dialogRef = this.dialog.open(ConsumerSignInComponent, {
          maxWidth: "400px",
          panelClass: Object.keys(this.settingsData).length > 0 && this.settingsData.form_bg_color ? "app-consumer-signin" : "app-consumer-sign-in",
          disableClose: true,
          data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
          //console.log(result);
          if (result == "success") {
            this.userInfo = this.commonSubscribeService.userInfo;
            this.ngOnInit()
          }
          this.storageService.deleteItem('skipIcRedirection');
        });
      }
    } else {
      this.redirectToWeb(plan, 'subscribe');
    }
  }

  subscribeToFreePlan(plan){
    let name = this.userInfo.user_display_name || this.userInfo.display_name

    let url = API.SUBSCRIBE_FREE_CHANNEL;
    let PAYLOAD = {
      amount: 0,
      finalAmount: 0,
      currency: null,
      organization_id: this.selectedPlan.organization_id,
      performer_id: JSON.stringify(this.selectedPlan.performer_id),
      tier_amount_mode: 'noExpiry',
      discount_percentage: this.selectedPlan.discount_val,
      response: {},
      name: name,
      plan_id: this.selectedPlan.id,
      channel_id: this.selectedPlan.channel_id ? this.selectedPlan.channel_id : 0,
      channel_name: this.performer_details.channel_display_name,
      channel_url: this.performer_details.channel_name,
      zip : null,
      invoice_id: null,
      tax_amount: 0,
      tax_rate: 0,
      creator_currency: this.selectedPlan.currency_type,
      processing_fee: this.selectedPlan.processingFee,
      sub_channel_url: this.route.snapshot.params.sub_channel_name ? this.settingsData.channelInfo.channel_name : '',
      sub_channel_name: this.route.snapshot.params.sub_channel_name ? this.settingsData.channelInfo.channel_display_name : '',
      benefits: this.selectedPlan.new_benefits
    };
    PAYLOAD['address'] = {
      street1: "",
      city: "",
      state: "",
      state_code: "",
      zip:"",
      country: "",
      country_code: ""
    };
    PAYLOAD.channel_id = this.selectedPlan.channel_id ? this.selectedPlan.channel_id : 0;
    PAYLOAD['selectedPlan'] = this.selectedPlan;

    this.appPaymentService.postRequest(url, PAYLOAD).subscribe(result => {
      if (result.status == 0) {
        this.toastr.success(result.message);
        this.ngOnInit();
      }else{
        if(result.status == 1 && result.message){
          this.toastr.error(result.message)
        }
      }
    }, error => {
      console.log(error);
    })

  }

  redirectToWeb(plan, type) {
    let url = environment.CONSUMER_PORTAL + this.router.url.split("/")[1] + "/subscription-list";
    let data = {
      type: type ? type : '',
      url: url,
      userInfo: this.userInfo
    }
    const dialogRef = this.dialog.open(IOSModalDialog, {
      panelClass: 'ios-modal',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  subType: any;
  changeSub(type, data?) {
    this.subType = type;
    //console.log(type, data)
    this.subscriptionList.forEach(ele => {
      if (ele.id == data.id && data) {
        if (this.subscription_details.length > 0) {
          this.subscription_details.forEach(sub => {
            if (ele.id == sub.plan_id) {
              ele.subType = sub.tier_amount_mode;
            }
          });
        } else {
          ele.subType = type;
        }
        // ele.subType = this.subscription_details[0] && type == this.subscription_details[0].tier_amount_mode ? this.subscription_details[0].tier_amount_mode : type ;
        data.tier_amounts.forEach(element => {
          // if (element.currency_type == this.currentLocation.currency.code) {
          //   ele.tier_amount = element.payment_amount;
          //   ele.currency = element.currency_type;
          //   ele.currency_type = element.currency_type;
          // }
          // else{
          if (ele.subType == element.frequency) {
            ele.discount_val = element.discount;
            ele.org_amount = Number(element.amount).toFixed(2);
            ele.current_currency = element.currency;
            ele.amount_after_dis_no_bf = (ele.org_amount - (ele.org_amount * ele.discount_val / 100));
            ele.amount_after_dis_no_bf = Number(ele.amount_after_dis_no_bf).toFixed(2);
            //   if(this.performer_details.booking_fee != 0){
            //   ele.booking_fee = (this.performer_details.booking_fee / 100) * ele.amount_after_dis_no_bf;
            //   ele.booking_fee = Number(ele.booking_fee).toFixed(2);
            //   ele.amount_after_dis = (Number(ele.booking_fee) + Number(ele.amount_after_dis_no_bf));
            //   ele.amount_after_dis = Number(ele.amount_after_dis).toFixed(2);
            // } else {
            if ((ele.processing_fee && ele.processing_fee == 1) || ele.processing_fee == undefined) {
              ele.processingFee = (ele.amount_after_dis_no_bf * (environment.processing_fee / 100)) + environment.fee_percentage;
              ele.processingFee = Number(ele.processingFee.toFixed(2));
              ele.amount_after_dis = (Number(ele.processingFee) + Number(ele.amount_after_dis_no_bf));
            } else if(ele.processing_fee == 0){
              ele.amount_after_dis = Number(ele.amount_after_dis_no_bf).toFixed(2);
            }
            // }
          }
          // ele.discount_val = ele.tier_amounts[ele.subType == ele.tier_amount_mode ? 0 : 1].discount;
          // ele.org_amount = Number(ele.tier_amounts[ele.subType == ele.tier_amount_mode ? 0 : 1].amount).toFixed(2);
          // ele.current_currency = ele.tier_amounts[ele.subType == ele.tier_amount_mode ? 0 : 1].currency;
          // ele.amount_after_dis = Number(ele.tier_amounts[ele.subType == ele.tier_amount_mode ? 0 : 1].amount - (ele.tier_amounts[ele.subType == ele.tier_amount_mode ? 0 : 1].amount * (ele.tier_amounts[0].discount/100))).toFixed(2);
          // ele.currency = ele.tier_amounts[ele.subType == 'monthly'? 0 : 1].currency;
          // ele.currency_type = ele.tier_amounts[ele.subType == 'monthly'? 0 : 1].currency;
          // ele.tier_amount = ele.tier_amounts[ele.subType == 'monthly'? 0 : 1].amounts[0].payment_amount;
          // }
        });
        ele.selectedPlan = this.commonSubscribeService.checkIsSubscribePlan(this.subscription_details, ele.id);
        ele.reActivePlan = this.commonSubscribeService.checkIsSubscribePlanReActive(this.subscription_details, ele.id);
        // e.selectedPlanValue = this.commonSubscribeService.getSelectedPlanValue(this.subscription_details, e.id);
        if (ele.selectedPlan || ele.reActivePlan) {
          this.commonSubscribeService.getSubscribedAmount(this.subscription_details, ele);
          if (this.route.snapshot.queryParams.returnUrl) {
            this.router.navigate([decodeURIComponent(this.route.snapshot.queryParams.returnUrl)]);
          }
        }
      } else if (this.subscription_details.length > 0) {
        this.subscription_details.forEach(sub => {
          if (ele.id == sub.plan_id) {
            ele.subType = sub.tier_amount_mode;
          }
        });
      }
      //  else if(this.subscription_details && this.subscription_details.length > 0 && (ele.id == this.subscription_details[0].plan_id)){
      //   ele.subType = type == this.subscription_details[0].tier_amount_mode ? this.subscription_details[0].tier_amount_mode : type ;
      // }
    });
    this.showMsg = true;
    let selectedPlanId = this.commonSubscribeService.getParam("plan_id");
    if (selectedPlanId) {
      this.subscriptionList.forEach(ele => {
        if(ele.id == selectedPlanId){
          this.selectedPlan = ele;
            this.isShownSideBar = true;
        }
      });
      
    }
    //console.log(this.subscriptionList, this.subscriptionList[0])
  }
  // A plan with channel_id > 0 belongs to a specific channel; otherwise it is a network-level plan.
  private getUnsubscribeTitle(plan: any): string {
    const planScope = plan && plan.channel_id ? 'channel' : 'network';
    return `Are you sure you want to unsubscribe from this ${planScope}?`;
  }

  UnsubscribeChannel(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} Unsubscribe clicked - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} Unsubscribe clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,

      clickAction:'unsubscribe'
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '370px',
      panelClass: 'app-confirmation-dialog',
      data: {
        title: this.getUnsubscribeTitle(data)
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        let reqData = {
          performer_id: data.performer_id,
          plan_id: data.id
        }
        this.appPaymentService.postRequest(API.CANCEL_CHANNEL_SUBSCRIPTION, reqData).subscribe(result => {
          if (result.status == 0) {
            this.getSubscriptionList();
          }
        }, error => {
          console.log(error);
        });
      }
    });
  }

  reactivePlan(data) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Album ${albumId} Reactive plan clicked - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `Album ${albumId} Reactive plan clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.performer_details?.organization_id || null,
      clickAction:'reactive'
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    let reqData = {
      performer_id: data.performer_id,
      plan_id: data.id
    }
    this.appPaymentService.postRequest(API.REACTIVATE_CHANNEL_SUBSCRIPTION, reqData).subscribe(result => {
      if (result.status == 0) {
        this.toastr.success("Subscription Plan Reactivated")
        this.getSubscriptionList();
      }
    }, error => {
      console.log(error);
    });
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    this.storageService.deleteItem('subscriptionChannelName');
    if (this.currencyInfoSubscription)
      this.currencyInfoSubscription.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    if (this.performerInfoSubscr)
      this.performerInfoSubscr.unsubscribe();
  }

}
